// Textos propis de la pàgina "hotel" per idioma (Hotel.jsx).

const textos = {
    es: {
        heroImageAlt: "Hotel en Camprodón",
        heroSmallTitle: "Una escapada en un lugar tranquilo y relajante",
        heroTitle: "Hotel en Camprodón",
        stickyWidgetsButtonHref: "/buscar2",
        stickyWidgetsButtonHref2: "/restaurante#reserva-restaurant",
        presentationTitle: "Tu hotel familiar en el Pirineo",
        presentationContent: <>{"El Hotel Camprodon es un hotel de gestión "}<strong>{"familiar "}</strong>{"que data del año 1914. De origen "}<strong>modernista</strong>, el hotel ha estado actualizado en varias ocasiones y hoy es un hotel actual, con todas las comodidades y servicios, donde se respira la historia y el romanticismo de principios del siglo XX en todos sus rincones.</>,
        sectionHeadSubtitle: "En el centro de Camprodón",
        sectionHeadTitle: "Conoce nuestras habitaciones",
        sectionHeadTexts: <>{"Las habitaciones del hotel son "}<strong>grandes y confortables</strong>{". En total, "}<strong>35 habitaciones</strong>{" cada una de ellas con su personalidad: contamos con habitaciones familiares grandes para familias, habitaciones dobles para escapadas románticas y habitaciones económicas para grupos de amigos con ganas de disfrutar de la naturaleza en los Pirineos."}</>,
        buttonHref: "/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/hotel/habitaciones",
        relatedRoomsImgAlt: "Habitación individual",
        relatedRoomsSmallTitle: "Habitaciones Hotel Camprodon",
        relatedRoomsTitle: "Habitación individual",
        relatedRoomsHref2: "/hotel/habitaciones",
        relatedRoomsImgAlt2: "Habitación Doble Básica",
        relatedRoomsSmallTitle2: "Habitaciones Hotel Camprodon",
        relatedRoomsTitle2: "Habitación Doble Básica",
        relatedRoomsHref3: "/hotel/habitaciones",
        relatedRoomsImgAlt3: "Habitación Doble Standard",
        relatedRoomsSmallTitle3: "Habitaciones Hotel Camprodon",
        relatedRoomsTitle3: "Habitación Doble Standard",
        relatedRoomsHref4: "/hotel/habitaciones",
        relatedRoomsImgAlt4: "Habitación Doble Superior",
        relatedRoomsSmallTitle4: "Habitaciones Hotel Camprodon",
        relatedRoomsTitle4: "Habitación Doble Superior",
        relatedRoomsHref5: "/hotel/habitaciones",
        relatedRoomsImgAlt5: "Habitación Doble Superior con Terraza",
        relatedRoomsSmallTitle5: "Habitaciones Hotel Camprodon",
        relatedRoomsTitle5: "Habitación Doble Superior con Terraza",
        relatedRoomsHref6: "/hotel/habitaciones",
        relatedRoomsImgAlt6: "Habitación Junior Suite",
        relatedRoomsSmallTitle6: "Habitaciones Hotel Camprodon",
        relatedRoomsTitle6: "Habitación Junior Suite",
        relatedRoomsHref7: "/hotel/habitaciones",
        relatedRoomsImgAlt7: "Habitación Familiar Cuádruple",
        relatedRoomsSmallTitle7: "Habitaciones Hotel Camprodon",
        relatedRoomsTitle7: "Habitación Familiar Cuádruple",
        sectionHeadSubtitle2: "Descubre nuestras instalaciones y servicios",
        sectionHeadTitle2: "Servicios del Hotel Camprodon",
        sectionHeadTexts2: <>{"El hotel cuenta con "}<strong>interiores cálidos y agradables</strong>{", propios del diseño modernista, con el Bar Albeniz y el restaurante. El exterior está rodeado de magníficas montañas, que ofrecen una marco idílico a tu estancia en el hotel y a tus días de descanso en nuestra "}<strong>piscina y jardín</strong>.</>,
        sectionHeadTexts3: <><em>No aceptamos animales de compañía</em>.</>,
        sliderControlsAboveAlt: "Tu hotel familiar en el Pirineo",
        cardTitle: "En el centro de Camprodón",
        cardContent: <>{"El Hotel Camprodon está situado en el "}<strong>centro de la población</strong>{". Las dos fachadas del hotel ofrecen vistas a sus "}<strong>35 habitaciones</strong>, unas con vistas a la plaza Doctor Robert i las otras al río Ter i al Pont Nou.</>,
        sliderControlsAboveAlt2: "Tu hotel familiar en el Pirineo",
        cardTitle2: "Desconecta alojándote con nosotros",
        cardContent2: <>{"El Hotel Camprodon es el lugar ideal para venir a disfrutar de un "}<strong>{"fin de semana "}</strong>{"o unas "}<strong>vacaciones en los Pirineos</strong>.</>,
        cardContent3: "¡Ven a descubrirnos!",
        sectionHeadSubtitle3: "Descubre las mejores ofertas en Camprodón",
        sectionHeadTitle3: "Ofertas del Hotel Camprodon",
        sectionHeadTexts4: "En el Hotel Camprodon ofrecemos paquetes y ofertas adaptadas a nuestros clientes.",
        sectionHeadTexts5: <>{"No pierdas la oportunidad de disfrutar de una "}<strong>experiencia única en Camprodón al mejor precio</strong>. ¡Explora nuestras ofertas hoy mismo y reserva tu estancia con nosotros!</>,
        buttonHref2: "/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "Escapada de 2 Noches en Camprodon",
        cardContent4: "Escapada de 2 noches en Camprodon los viernes y sábados desde el 7 de enero hasta el 28 de febrero (excepto el fin de semana del 13 de febrero). Incluye alojamiento, desayuno y acceso a instalaciones del hotel para disfrutar del Pirineo catalán en invierno.",
        linkHref: "/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Descubre Camprodón",
        sectionHeadTitle4: "¿Qué hacer en Camprodón?",
        sectionHeadTexts6: <>{"Ven a descubrir la naturaleza en el "}<strong>Pirineo de Girona</strong>{" y no te pierdas los pueblos de la "}<strong>Vall de Camprodón</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Disfruta del Pirineo más auténtico con el Hotel Camprodon.",
        buttonHref3: "/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "Tu hotel familiar en el Pirineo",
        environmentContent: "Camprodón es conocido por su rica historia y cultura, y es un lugar ideal para aquellos que buscan una escapada tranquila y relajante.",
    },
    ca: {
        heroImageAlt: "Hotel a Camprodon",
        heroSmallTitle: "Una escapada en un lloc tranquil i relaxant",
        heroTitle: "Hotel a Camprodon",
        stickyWidgetsButtonHref: "/ca/buscar2",
        stickyWidgetsButtonHref2: "/ca/restaurant#reserva-restaurant",
        presentationTitle: "El teu hotel familiar al Pirineu",
        presentationContent: <>{"L’Hotel Camprodon és un hotel de gestió "}<strong>{"familiar "}</strong>{"que data de l’any 1914. D’origen "}<strong>modernista</strong>, l’hotel ha estat actualitzat en diverses ocasions i avui és un hotel actual, amb totes les comoditats i serveis, on es respira la història i el romanticisme de principis de segle XX en tots els racons.</>,
        sectionHeadSubtitle: "Al centre de Camprodon",
        sectionHeadTitle: "Coneix les nostres habitacions",
        sectionHeadTexts: <>{"Les habitacions de l’hotel són "}<strong>grans i confortables</strong>{". En total, "}<strong>35 habitacions</strong>{" cadascuna amb la seva personalitat: comptem amb habitacions familiars grans per a famílies, habitacions dobles per a escapades romàntiques i habitacions econòmiques per a grups d’amics amb ganes de gaudir de la natura als Pirineus."}</>,
        buttonHref: "/ca/hotel/habitacions",
        button: " Veure tot ",
        relatedRoomsHref: "/ca/hotel/habitacions",
        relatedRoomsImgAlt: "Habitació individual",
        relatedRoomsSmallTitle: "Habitacions Hotel Camprodon",
        relatedRoomsTitle: "Habitació individual",
        relatedRoomsHref2: "/ca/hotel/habitacions",
        relatedRoomsImgAlt2: "Habitació Doble Bàsica",
        relatedRoomsSmallTitle2: "Habitacions Hotel Camprodon",
        relatedRoomsTitle2: "Habitació Doble Bàsica",
        relatedRoomsHref3: "/ca/hotel/habitacions",
        relatedRoomsImgAlt3: "Habitació doble standard",
        relatedRoomsSmallTitle3: "Habitacions Hotel Camprodon",
        relatedRoomsTitle3: "Habitació doble standard",
        relatedRoomsHref4: "/ca/hotel/habitacions",
        relatedRoomsImgAlt4: "Habitació Doble Superior",
        relatedRoomsSmallTitle4: "Habitacions Hotel Camprodon",
        relatedRoomsTitle4: "Habitació doble superior",
        relatedRoomsHref5: "/ca/hotel/habitacions",
        relatedRoomsImgAlt5: "Habitació Doble Superior amb Terrassa",
        relatedRoomsSmallTitle5: "Habitacions Hotel Camprodon",
        relatedRoomsTitle5: "Habitació doble superior amb terrassa",
        relatedRoomsHref6: "/ca/hotel/habitacions",
        relatedRoomsImgAlt6: "Habitació Junior Suite",
        relatedRoomsSmallTitle6: "Habitacions Hotel Camprodon",
        relatedRoomsTitle6: "Habitació Junior Suite",
        relatedRoomsHref7: "/ca/hotel/habitacions",
        relatedRoomsImgAlt7: "Habitació Familiar Quàdruple",
        relatedRoomsSmallTitle7: "Habitacions Hotel Camprodon",
        relatedRoomsTitle7: "Habitació Familiar Quàdruple",
        sectionHeadSubtitle2: "Descobreix les nostres instal·lacions i serveis",
        sectionHeadTitle2: "Serveis de l'Hotel Camprodon",
        sectionHeadTexts2: <>{"L’hotel compta amb "}<strong>interiors càlids i agradables</strong>{", propis de l’emblemàtic disseny noucentista, amb el Bar Albeniz i el restaurant. A l’exterior, l’hotel està envoltat de magnífiques muntanyes, que ofereixen el marc idíl·lic a la vostra estada i als vostres dies de descans al nostre "}<strong>jardí i piscina</strong>.</>,
        sectionHeadTexts3: <><em>{"No acceptem animals de companyia. "}</em></>,
        serviceItemIconAlt2: "Pàrquing",
        serviceItemTitle2: "Pàrquing",
        serviceItemIconAlt3: "Guarda bicis",
        serviceItemTitle3: "Guarda bicis",
        serviceItemIconAlt6: "Pàrquing exterior",
        serviceItemTitle6: "Pàrquing exterior",
        serviceItemIconAlt9: "Adaptat a persones amb mobilitat reduïda",
        serviceItemTitle9: "Adaptat a persones amb mobilitat reduïda",
        serviceItemIconAlt10: "Pàrquing interior",
        serviceItemTitle10: "Pàrquing interior",
        serviceItemIconAlt13: "Mini bar",
        serviceItemTitle13: "Mini bar",
        serviceItemIconAlt19: "Solarium",
        serviceItemTitle19: "Solarium",
        serviceItemIconAlt20: "Terrassa",
        serviceItemTitle20: "Terrassa",
        serviceItemIconAlt21: "Trànsfer",
        serviceItemTitle21: "Trànsfer",
        serviceItemIconAlt22: "Tv",
        serviceItemTitle22: "Tv",
        sliderControlsAboveAlt: "El teu hotel familiar al Pirineu",
        cardTitle: "Al centre de Camprodon",
        cardContent: <>{"L’Hotel Camprodon està situat al "}<strong>centre de la població</strong>{" de Camprodon. Les dues façanes de l’hotel ofereixen vistes privilegiades a les seves "}<strong>35 habitacions</strong>: unes amb vista a la Plaça del Doctor Robert i les altres al riu Ter i al Pont Nou.</>,
        sliderControlsAboveAlt2: "El teu hotel familiar al Pirineu",
        cardTitle2: "Desconnecta allotjant-te amb nosaltres",
        cardContent2: <>{"L’Hotel Camprodon és el lloc ideal per a venir a gaudir d’un "}<strong>cap de setmana</strong>{" o unes "}<strong>vacances als Pirineus</strong>.</>,
        cardContent3: "Vine a descobrir-nos!",
        sectionHeadSubtitle3: "Descobreix les millors ofertes a Camprodon",
        sectionHeadTitle3: "Ofertes de l'Hotel Camprodon",
        sectionHeadTexts4: "A l'Hotel Camprodon oferim paquets i ofertes adaptades als nostres clients.",
        sectionHeadTexts5: <>{"No perdeu l'oportunitat de gaudir d'una "}<strong>experiència única a Camprodon al millor preu</strong>. Explora les nostres ofertes avui mateix i reserva la teva estada amb nosaltres!</>,
        buttonHref2: "/ca/ofertes-hotel-camprodon-girona/oferta-2-nits",
        button2: " Veure tot ",
        cardContent4: <></>,
        linkHref: "/ca/ofertes-hotel-camprodon-girona/oferta-2-nits",
        sectionHeadSubtitle4: "Descobreix Camprodon",
        sectionHeadTitle4: "Què fer a Camprodon?",
        sectionHeadTexts6: <>{"Vine a descobrir la natura al "}<strong>Pirineu de Girona</strong>{", i no et perdis els pobles de la "}<strong>Vall de Camprodon</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Gaudeix del Pirineu més autèntic amb l’Hotel Camprodon.",
        buttonHref3: "/ca/que-fer-a-camprodon-girona",
        button3: " Veure tot ",
        environmentImgAlt: "El teu hotel familiar al Pirineu",
        environmentContent: "Camprodon és conegut per la seva rica història i cultura, i és un lloc ideal per a aquells que busquen una escapada tranquil·la i relaxant.",
    },
    en: {
        heroImageAlt: "Hotel in Camprodon",
        heroSmallTitle: "A getaway in a quiet and relaxing place",
        heroTitle: "Hotel in Camprodon",
        stickyWidgetsButtonHref: "/en/buscar2",
        stickyWidgetsButtonHref2: "/en/restaurant#reserva-restaurant",
        iconAlt: "Secure reservation",
        benefitsSliderBenefit: "Secure reservation",
        iconAlt2: "Immediate confirmation",
        benefitsSliderBenefit2: "Immediate confirmation",
        presentationTitle: "Your family hotel in the Pyrenees",
        presentationContent: <>{"Hotel Camprodon is a "}<strong>family-run hotel</strong>{" dating back to 1914. Originally of "}<strong>Art Nouveau style</strong>, the hotel has been refurbished several times, and today it is a modern hotel with all amenities and services, emanating history and early twentieth century romance from every corner.</>,
        sectionHeadSubtitle: "In the center of Camprodon",
        sectionHeadTitle: "Discover our rooms",
        sectionHeadTexts: <>{"Hotel Camprodon’s rooms are "}<strong>large and comfortable</strong>{". In total, "}<strong>{"35 rooms "}</strong>each with their own personality: we have large rooms for families, double rooms for romantic getaways and budget rooms for groups of friends willing to enjoy nature in the Pyrenees.</>,
        buttonHref: "/en/hotel/rooms",
        button: " See all ",
        relatedRoomsHref: "/en/hotel/rooms",
        relatedRoomsImgAlt: "Single room",
        relatedRoomsSmallTitle: "Camprodon Hotel rooms",
        relatedRoomsTitle: "Single room",
        relatedRoomsHref2: "/en/hotel/rooms",
        relatedRoomsImgAlt2: "Basic Double Room",
        relatedRoomsSmallTitle2: "Hotel Camprodon rooms",
        relatedRoomsTitle2: "Basic Double Room",
        relatedRoomsHref3: "/en/hotel/rooms",
        relatedRoomsImgAlt3: "Standard Double Room",
        relatedRoomsSmallTitle3: "Hotel Camprodon rooms",
        relatedRoomsTitle3: "Standard Double Room",
        relatedRoomsHref4: "/en/hotel/rooms",
        relatedRoomsImgAlt4: "Double superior room",
        relatedRoomsSmallTitle4: "Hotel Camprodon rooms",
        relatedRoomsTitle4: "Superior Double Room",
        relatedRoomsHref5: "/en/hotel/rooms",
        relatedRoomsImgAlt5: "Superior Double Room with Terrace",
        relatedRoomsSmallTitle5: "Hotel Camprodon rooms",
        relatedRoomsTitle5: "Superior Double Room with Terrace",
        relatedRoomsHref6: "/en/hotel/rooms",
        relatedRoomsImgAlt6: "Junior Suite Room",
        relatedRoomsSmallTitle6: "Hotel Camprodon rooms",
        relatedRoomsTitle6: "Junior Suite Room",
        relatedRoomsHref7: "/en/hotel/rooms",
        relatedRoomsImgAlt7: "Quadruple Family Room",
        relatedRoomsSmallTitle7: "Hotel Camprodon rooms",
        relatedRoomsTitle7: "Quadruple Family Room",
        sectionHeadSubtitle2: "Discover our facilities and services",
        sectionHeadTitle2: "Camprodon Hotel Services",
        sectionHeadTexts2: <>{"All common rooms are "}<strong>warm and pleasant</strong>{", due to the iconic Art Nouveau design, especially the grand but cozy restaurant and Bar Albeniz. Outside, the hotel is surrounded by magnificent mountains, providing an idyllic setting for your stay and your days of rest in our "}<strong>garden and pool</strong>.</>,
        sectionHeadTexts3: <><em>We do not accept pets</em>.</>,
        serviceItemIconAlt: "Wifi",
        serviceItemTitle: "Wifi",
        serviceItemIconAlt3: "Safe storage for bicycles",
        serviceItemTitle3: "Safe storage for bicycles",
        serviceItemIconAlt4: "Conference hall",
        serviceItemTitle4: "Conference hall",
        serviceItemIconAlt5: "Communicating rooms",
        serviceItemTitle5: "Communicating rooms",
        serviceItemIconAlt7: "Gluten-free menu",
        serviceItemTitle7: "Gluten-free menu",
        serviceItemIconAlt8: "Hair-drier",
        serviceItemTitle8: "Hair-drier",
        serviceItemIconAlt11: "Foreign languages spoken",
        serviceItemTitle11: "Foreign languages spoken",
        serviceItemIconAlt12: "Laundry service",
        serviceItemTitle12: "Laundry service",
        serviceItemIconAlt13: "Mini bar",
        serviceItemTitle13: "Mini bar",
        serviceItemIconAlt14: "Multi-service room",
        serviceItemTitle14: "Multi-service room",
        serviceItemIconAlt15: "Telephone",
        serviceItemTitle15: "Telephone",
        serviceItemIconAlt16: "Swimming pool",
        serviceItemTitle16: "Swimming pool",
        serviceItemIconAlt17: "Newspapers on demand",
        serviceItemTitle17: "Newspapers on demand",
        serviceItemIconAlt18: "Safe deposit box",
        serviceItemTitle18: "Safe deposit box",
        serviceItemIconAlt19: "Solarium",
        serviceItemTitle19: "Solarium",
        serviceItemIconAlt21: "Transfer service",
        serviceItemTitle21: "Transfer service",
        serviceItemIconAlt22: "Tv",
        serviceItemTitle22: "Tv",
        serviceItemIconAlt23: "Baths for babies",
        serviceItemTitle23: "Baths for babies",
        sliderControlsAboveAlt: "Your family hotel in the Pyrenees",
        cardTitle: "In the center of Camprodon",
        cardContent: <>{"Hotel Camprodon is located in the center of the town. The two hotel facades bring spectacular views to all its "}<strong>35 rooms</strong>: some overlooking the Plaça Doctor Robert and the rest overlooking river Ter and the Pont Nou (new bridge).</>,
        sliderControlsAboveAlt2: "Your family hotel in the Pyrenees",
        cardTitle2: "Disconnect staying with us",
        cardContent2: <>{"Hotel Camprodon is the ideal place to come and enjoy a "}<strong>{"weekend "}</strong>{"or a "}<strong>{"holiday in the Pyrenees. "}</strong></>,
        cardContent3: "Come and discover us!",
        sectionHeadSubtitle3: "Discover the best offers in Camprodon",
        sectionHeadTitle3: "Hotel Camprodon Offers",
        sectionHeadTexts4: "At Hotel Camprodon we offer packages and offers tailored to our clients.",
        sectionHeadTexts5: <>{"Do not miss the opportunity to enjoy a "}<strong>unique experience in Camprodon at the best price</strong>. Explore our offers today and book your stay with us!</>,
        buttonHref2: "/en/hotel-deals-camprodon-spain",
        button2: " See all ",
        cardHeaderAlt: "Offer 2 nights",
        cardTitle3: "Offer 2 nights",
        cardContent4: <></>,
        cardFooter: <><a href="/en/hotel-deals-camprodon-spain/offer-2-nights" className="c-link">Find out</a></>,
        sectionHeadSubtitle4: "Discover Camprodon",
        sectionHeadTitle4: "What to do in Camprodon?",
        sectionHeadTexts6: <>{"Come and discover the nature in the "}<strong>Pyrenees of Girona</strong>{", and do not miss other towns on the "}<strong>Camprodon Valley</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Enjoy the Pyrenees at their most authentic at Hotel Camprodon.",
        buttonHref3: "/en/what-to-do-in-camprodon-spain",
        button3: " See all ",
        environmentImgAlt: "Your family hotel in the Pyrenees",
        environmentContent: "Camprodon is known for its rich history and culture, and is an ideal location for those looking for a quiet and relaxing getaway.",
    },
    fr: {
        heroImageAlt: "Hôtel à Camprodon",
        heroSmallTitle: "Une escapade dans un lieu calme et reposant",
        heroTitle: "Hôtel à Camprodon",
        stickyWidgetsButtonHref: "/fr/buscar2",
        stickyWidgetsButtonHref2: "/fr/restaurant#reserva-restaurant",
        presentationTitle: "Votre hôtel familial dans les Pyrénées",
        presentationContent: <>{"L'Hotel Camprodon est un hôtel à gestion "}<strong>familiale</strong>{" qui date de 1914. D'origine "}<strong>moderniste</strong>, l'hôtel a été rénové à plusieurs reprises et c'est aujourd'hui un hôtel actuel, avec tout le confort et les services, où l'on respire dans chaque recoin l'histoire et le romantisme du début du XXe siècle.</>,
        sectionHeadSubtitle: "Au centre de Camprodon",
        sectionHeadTitle: "Découvrez nos chambres",
        sectionHeadTexts: <>{"Les chambres de l'hôtel sont "}<strong>grandes et confortables</strong>{". Au total, "}<strong>35 chambres</strong>, chacune avec sa personnalité : grandes chambres familiales pour les familles, chambres doubles pour les escapades romantiques et chambres économiques pour les groupes d'amis désireux de profiter de la nature dans les Pyrénées.</>,
        buttonHref: "/fr/hotel/chambres",
        button: " Ver todo ",
        relatedRoomsHref: "/fr/hotel/chambres",
        relatedRoomsImgAlt: "Chambre individuelle",
        relatedRoomsSmallTitle: "Chambres Hotel Camprodon",
        relatedRoomsTitle: "Chambre individuelle",
        relatedRoomsHref2: "/fr/hotel/chambres",
        relatedRoomsImgAlt2: "Chambre double basique",
        relatedRoomsSmallTitle2: "Chambres Hotel Camprodon",
        relatedRoomsTitle2: "Chambre double basique",
        relatedRoomsHref3: "/fr/hotel/chambres",
        relatedRoomsImgAlt3: "Chambre double standard",
        relatedRoomsSmallTitle3: "Chambres Hotel Camprodon",
        relatedRoomsTitle3: "Chambre double standard",
        relatedRoomsHref4: "/fr/hotel/chambres",
        relatedRoomsImgAlt4: "Chambre double supérieure",
        relatedRoomsSmallTitle4: "Chambres Hotel Camprodon",
        relatedRoomsTitle4: "Chambre double supérieure",
        relatedRoomsHref5: "/fr/hotel/chambres",
        relatedRoomsImgAlt5: "Chambre double supérieure avec terrasse",
        relatedRoomsSmallTitle5: "Chambres Hotel Camprodon",
        relatedRoomsTitle5: "Chambre double supérieure avec terrasse",
        relatedRoomsHref6: "/fr/hotel/chambres",
        relatedRoomsImgAlt6: "Chambre Junior Suite",
        relatedRoomsSmallTitle6: "Chambres Hotel Camprodon",
        relatedRoomsTitle6: "Chambre Junior Suite",
        relatedRoomsHref7: "/fr/hotel/chambres",
        relatedRoomsImgAlt7: "Chambre familiale quadruple",
        relatedRoomsSmallTitle7: "Chambres Hotel Camprodon",
        relatedRoomsTitle7: "Chambre familiale quadruple",
        sectionHeadSubtitle2: "Découvrez nos installations et services",
        sectionHeadTitle2: "Services de l'Hotel Camprodon",
        sectionHeadTexts2: <>L'hôtel dispose d'<strong>intérieurs chaleureux et agréables</strong>{", typiques du design moderniste, avec le Bar Albeniz et le restaurant. L'extérieur est entouré de magnifiques montagnes, qui offrent un cadre idyllique à votre séjour et à vos journées de détente dans notre "}<strong>piscine et jardin</strong>.</>,
        sectionHeadTexts3: <><em>Les animaux de compagnie ne sont pas acceptés</em>.</>,
        sliderControlsAboveAlt: "Votre hôtel familial dans les Pyrénées",
        cardTitle: "Au centre de Camprodon",
        cardContent: <>{"L'Hotel Camprodon est situé au "}<strong>centre du village</strong>{". Les deux façades de l'hôtel offrent des vues à ses "}<strong>35 chambres</strong>{" : les unes donnent sur la place Doctor Robert et les autres sur le Ter et le Pont Nou."}</>,
        sliderControlsAboveAlt2: "Votre hôtel familial dans les Pyrénées",
        cardTitle2: "Déconnectez en séjournant chez nous",
        cardContent2: <>{"L'Hotel Camprodon est l'endroit idéal pour venir profiter d'un "}<strong>week-end</strong>{" ou de "}<strong>vacances dans les Pyrénées</strong>.</>,
        cardContent3: "Venez nous découvrir !",
        sectionHeadSubtitle3: "Découvrez les meilleures offres à Camprodon",
        sectionHeadTitle3: "Offres de l'Hotel Camprodon",
        sectionHeadTexts4: "À l'Hotel Camprodon, nous proposons des forfaits et des offres adaptés à nos clients.",
        sectionHeadTexts5: <>{"Ne manquez pas l'occasion de vivre une "}<strong>expérience unique à Camprodon au meilleur prix</strong>. Découvrez nos offres dès aujourd'hui et réservez votre séjour avec nous !</>,
        buttonHref2: "/fr/offres-hotel-camprodon-espagne/offre-2-nuits",
        button2: " Ver todo ",
        cardTitle3: "Escapade de 2 nuits à Camprodon",
        cardContent4: "Escapade de 2 nuits à Camprodon les vendredis et samedis du 7 janvier au 28 février (sauf le week-end du 13 février). Comprend l'hébergement, le petit-déjeuner et l'accès aux installations de l'hôtel pour profiter des Pyrénées catalanes en hiver.",
        linkHref: "/fr/offres-hotel-camprodon-espagne/offre-2-nuits",
        sectionHeadSubtitle4: "Découvrez Camprodon",
        sectionHeadTitle4: "Que faire à Camprodon ?",
        sectionHeadTexts6: <>{"Venez découvrir la nature dans les "}<strong>Pyrénées de Gérone</strong>{" et ne manquez pas les villages de la "}<strong>vallée de Camprodon</strong>{" : Setcases, Llanars, Molló..."}</>,
        sectionHeadTexts7: "Profitez des Pyrénées les plus authentiques avec l'Hotel Camprodon.",
        buttonHref3: "/fr/que-faire-a-camprodon-espagne",
        button3: " Ver todo ",
        environmentImgAlt: "Votre hôtel familial dans les Pyrénées",
        environmentContent: "Camprodon est connu pour sa riche histoire et sa culture, et c'est un lieu idéal pour ceux qui recherchent une escapade calme et reposante.",
    },
    de: {
        heroImageAlt: "Hotel in Camprodon",
        heroSmallTitle: "Eine Auszeit an einem ruhigen und erholsamen Ort",
        heroTitle: "Hotel in Camprodon",
        stickyWidgetsButtonHref: "/de/buscar2",
        stickyWidgetsButtonHref2: "/de/restaurante#reserva-restaurant",
        presentationTitle: "Ihr Familienhotel in den Pyrenäen",
        presentationContent: <>{"Das Hotel Camprodon ist ein "}<strong>familiengeführtes</strong>{" Hotel aus dem Jahr 1914. Im "}<strong>Jugendstil</strong>{" erbaut, wurde das Hotel mehrfach modernisiert und ist heute ein zeitgemäßes Haus mit allem Komfort, in dem man in jeder Ecke die Geschichte und Romantik des frühen 20. Jahrhunderts spürt."}</>,
        sectionHeadSubtitle: "Im Zentrum von Camprodon",
        sectionHeadTitle: "Entdecken Sie unsere Zimmer",
        sectionHeadTexts: <>{"Die Zimmer des Hotels sind "}<strong>groß und komfortabel</strong>{". Insgesamt "}<strong>35 Zimmer</strong>, jedes mit eigenem Charakter: große Familienzimmer, Doppelzimmer für romantische Auszeiten und günstige Zimmer für Freundesgruppen, die die Natur der Pyrenäen genießen möchten.</>,
        buttonHref: "/de/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/de/hotel/habitaciones",
        relatedRoomsImgAlt: "Einzelzimmer",
        relatedRoomsSmallTitle: "Zimmer Hotel Camprodon",
        relatedRoomsTitle: "Einzelzimmer",
        relatedRoomsHref2: "/de/hotel/habitaciones",
        relatedRoomsImgAlt2: "Doppelzimmer Basic",
        relatedRoomsSmallTitle2: "Zimmer Hotel Camprodon",
        relatedRoomsTitle2: "Doppelzimmer Basic",
        relatedRoomsHref3: "/de/hotel/habitaciones",
        relatedRoomsImgAlt3: "Doppelzimmer Standard",
        relatedRoomsSmallTitle3: "Zimmer Hotel Camprodon",
        relatedRoomsTitle3: "Doppelzimmer Standard",
        relatedRoomsHref4: "/de/hotel/habitaciones",
        relatedRoomsImgAlt4: "Doppelzimmer Superior",
        relatedRoomsSmallTitle4: "Zimmer Hotel Camprodon",
        relatedRoomsTitle4: "Doppelzimmer Superior",
        relatedRoomsHref5: "/de/hotel/habitaciones",
        relatedRoomsImgAlt5: "Doppelzimmer Superior mit Terrasse",
        relatedRoomsSmallTitle5: "Zimmer Hotel Camprodon",
        relatedRoomsTitle5: "Doppelzimmer Superior mit Terrasse",
        relatedRoomsHref6: "/de/hotel/habitaciones",
        relatedRoomsImgAlt6: "Junior Suite",
        relatedRoomsSmallTitle6: "Zimmer Hotel Camprodon",
        relatedRoomsTitle6: "Junior Suite",
        relatedRoomsHref7: "/de/hotel/habitaciones",
        relatedRoomsImgAlt7: "Familienzimmer für vier Personen",
        relatedRoomsSmallTitle7: "Zimmer Hotel Camprodon",
        relatedRoomsTitle7: "Familienzimmer für vier Personen",
        sectionHeadSubtitle2: "Entdecken Sie unsere Einrichtungen und Leistungen",
        sectionHeadTitle2: "Leistungen des Hotel Camprodon",
        sectionHeadTexts2: <>{"Das Hotel bietet "}<strong>warme und gemütliche Innenräume</strong>{" im typischen Jugendstil, mit der Bar Albeniz und dem Restaurant. Draußen ist es von herrlichen Bergen umgeben, die einen idyllischen Rahmen für Ihren Aufenthalt und Ihre Erholungstage an unserem "}<strong>Pool und Garten</strong>{" bilden."}</>,
        sectionHeadTexts3: <><em>Haustiere sind nicht erlaubt</em>.</>,
        sliderControlsAboveAlt: "Ihr Familienhotel in den Pyrenäen",
        cardTitle: "Im Zentrum von Camprodon",
        cardContent: <>{"Das Hotel Camprodon liegt im "}<strong>Ortszentrum</strong>{". Die beiden Fassaden des Hotels bieten seinen "}<strong>35 Zimmern</strong>{" Ausblicke – teils auf die Plaça Doctor Robert, teils auf den Ter und die Pont Nou."}</>,
        sliderControlsAboveAlt2: "Ihr Familienhotel in den Pyrenäen",
        cardTitle2: "Abschalten bei uns",
        cardContent2: <>{"Das Hotel Camprodon ist der ideale Ort für ein "}<strong>Wochenende</strong>{" oder einen "}<strong>Urlaub in den Pyrenäen</strong>.</>,
        cardContent3: "Entdecken Sie uns!",
        sectionHeadSubtitle3: "Entdecken Sie die besten Angebote in Camprodon",
        sectionHeadTitle3: "Angebote des Hotel Camprodon",
        sectionHeadTexts4: "Im Hotel Camprodon bieten wir Pakete und Angebote, die auf unsere Gäste zugeschnitten sind.",
        sectionHeadTexts5: <>{"Lassen Sie sich die Gelegenheit nicht entgehen, ein "}<strong>einzigartiges Erlebnis in Camprodon zum besten Preis</strong>{" zu genießen. Entdecken Sie noch heute unsere Angebote und buchen Sie Ihren Aufenthalt bei uns!"}</>,
        buttonHref2: "/de/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "2-Nächte-Auszeit in Camprodon",
        cardContent4: "2-Nächte-Auszeit in Camprodon freitags und samstags vom 7. Januar bis 28. Februar (außer am Wochenende des 13. Februar). Inklusive Übernachtung, Frühstück und Nutzung der Hoteleinrichtungen, um die katalanischen Pyrenäen im Winter zu genießen.",
        linkHref: "/de/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Entdecken Sie Camprodon",
        sectionHeadTitle4: "Was kann man in Camprodon unternehmen?",
        sectionHeadTexts6: <>{"Entdecken Sie die Natur in den "}<strong>Pyrenäen von Girona</strong>{" und verpassen Sie nicht die Dörfer des "}<strong>Camprodon-Tals</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Genießen Sie die ursprünglichsten Pyrenäen mit dem Hotel Camprodon.",
        buttonHref3: "/de/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "Ihr Familienhotel in den Pyrenäen",
        environmentContent: "Camprodon ist für seine reiche Geschichte und Kultur bekannt und ein idealer Ort für alle, die eine ruhige und erholsame Auszeit suchen.",
    },
    it: {
        heroImageAlt: "Hotel a Camprodon",
        heroSmallTitle: "Una fuga in un luogo tranquillo e rilassante",
        heroTitle: "Hotel a Camprodon",
        stickyWidgetsButtonHref: "/it/buscar2",
        stickyWidgetsButtonHref2: "/it/restaurante#reserva-restaurant",
        presentationTitle: "Il tuo hotel per famiglie nei Pirenei",
        presentationContent: <>{"L'Hotel Camprodon è un hotel a gestione "}<strong>familiare</strong>{" che risale al 1914. Di origine "}<strong>modernista</strong>, l'hotel è stato rinnovato in diverse occasioni e oggi è un hotel moderno, con tutti i comfort e i servizi, dove in ogni angolo si respirano la storia e il romanticismo dell'inizio del XX secolo.</>,
        sectionHeadSubtitle: "Nel centro di Camprodon",
        sectionHeadTitle: "Scopri le nostre camere",
        sectionHeadTexts: <>{"Le camere dell'hotel sono "}<strong>grandi e confortevoli</strong>{". In totale "}<strong>35 camere</strong>, ciascuna con la sua personalità: grandi camere familiari per le famiglie, camere doppie per fughe romantiche e camere economiche per gruppi di amici desiderosi di godersi la natura nei Pirenei.</>,
        buttonHref: "/it/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/it/hotel/habitaciones",
        relatedRoomsImgAlt: "Camera singola",
        relatedRoomsSmallTitle: "Camere Hotel Camprodon",
        relatedRoomsTitle: "Camera singola",
        relatedRoomsHref2: "/it/hotel/habitaciones",
        relatedRoomsImgAlt2: "Camera doppia basic",
        relatedRoomsSmallTitle2: "Camere Hotel Camprodon",
        relatedRoomsTitle2: "Camera doppia basic",
        relatedRoomsHref3: "/it/hotel/habitaciones",
        relatedRoomsImgAlt3: "Camera doppia standard",
        relatedRoomsSmallTitle3: "Camere Hotel Camprodon",
        relatedRoomsTitle3: "Camera doppia standard",
        relatedRoomsHref4: "/it/hotel/habitaciones",
        relatedRoomsImgAlt4: "Camera doppia superior",
        relatedRoomsSmallTitle4: "Camere Hotel Camprodon",
        relatedRoomsTitle4: "Camera doppia superior",
        relatedRoomsHref5: "/it/hotel/habitaciones",
        relatedRoomsImgAlt5: "Camera doppia superior con terrazza",
        relatedRoomsSmallTitle5: "Camere Hotel Camprodon",
        relatedRoomsTitle5: "Camera doppia superior con terrazza",
        relatedRoomsHref6: "/it/hotel/habitaciones",
        relatedRoomsImgAlt6: "Camera Junior Suite",
        relatedRoomsSmallTitle6: "Camere Hotel Camprodon",
        relatedRoomsTitle6: "Camera Junior Suite",
        relatedRoomsHref7: "/it/hotel/habitaciones",
        relatedRoomsImgAlt7: "Camera familiare quadrupla",
        relatedRoomsSmallTitle7: "Camere Hotel Camprodon",
        relatedRoomsTitle7: "Camera familiare quadrupla",
        sectionHeadSubtitle2: "Scopri le nostre strutture e i nostri servizi",
        sectionHeadTitle2: "Servizi dell'Hotel Camprodon",
        sectionHeadTexts2: <>{"L'hotel offre "}<strong>interni caldi e accoglienti</strong>{", tipici del design modernista, con il Bar Albeniz e il ristorante. L'esterno è circondato da magnifiche montagne, che offrono una cornice idilliaca al tuo soggiorno e alle tue giornate di relax nella nostra "}<strong>piscina e giardino</strong>.</>,
        sectionHeadTexts3: <><em>Non accettiamo animali domestici</em>.</>,
        sliderControlsAboveAlt: "Il tuo hotel per famiglie nei Pirenei",
        cardTitle: "Nel centro di Camprodon",
        cardContent: <>{"L'Hotel Camprodon si trova nel "}<strong>centro del paese</strong>{". Le due facciate dell'hotel offrono vista alle sue "}<strong>35 camere</strong>: alcune affacciano su piazza Doctor Robert e le altre sul fiume Ter e sul Pont Nou.</>,
        sliderControlsAboveAlt2: "Il tuo hotel per famiglie nei Pirenei",
        cardTitle2: "Stacca la spina soggiornando da noi",
        cardContent2: <>{"L'Hotel Camprodon è il luogo ideale per venire a goderti un "}<strong>fine settimana</strong>{" o una "}<strong>vacanza nei Pirenei</strong>.</>,
        cardContent3: "Vieni a scoprirci!",
        sectionHeadSubtitle3: "Scopri le migliori offerte a Camprodon",
        sectionHeadTitle3: "Offerte dell'Hotel Camprodon",
        sectionHeadTexts4: "All'Hotel Camprodon offriamo pacchetti e offerte pensati per i nostri clienti.",
        sectionHeadTexts5: <>Non perdere l'occasione di vivere un'<strong>esperienza unica a Camprodon al miglior prezzo</strong>. Scopri oggi stesso le nostre offerte e prenota il tuo soggiorno con noi!</>,
        buttonHref2: "/it/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "Fuga di 2 notti a Camprodon",
        cardContent4: "Fuga di 2 notti a Camprodon il venerdì e il sabato dal 7 gennaio al 28 febbraio (escluso il fine settimana del 13 febbraio). Include alloggio, colazione e accesso alle strutture dell'hotel per goderti i Pirenei catalani in inverno.",
        linkHref: "/it/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Scopri Camprodon",
        sectionHeadTitle4: "Cosa fare a Camprodon?",
        sectionHeadTexts6: <>{"Vieni a scoprire la natura nei "}<strong>Pirenei di Girona</strong>{" e non perderti i paesi della "}<strong>Valle di Camprodon</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Goditi i Pirenei più autentici con l'Hotel Camprodon.",
        buttonHref3: "/it/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "Il tuo hotel per famiglie nei Pirenei",
        environmentContent: "Camprodon è nota per la sua ricca storia e cultura ed è il luogo ideale per chi cerca una fuga tranquilla e rilassante.",
    },
    pt: {
        heroImageAlt: "Hotel em Camprodon",
        heroSmallTitle: "Uma escapadinha num lugar tranquilo e relaxante",
        heroTitle: "Hotel em Camprodon",
        stickyWidgetsButtonHref: "/pt/buscar2",
        stickyWidgetsButtonHref2: "/pt/restaurante#reserva-restaurant",
        presentationTitle: "O seu hotel familiar nos Pirenéus",
        presentationContent: <>{"O Hotel Camprodon é um hotel de gestão "}<strong>familiar</strong>{" que data de 1914. De origem "}<strong>modernista</strong>, o hotel foi atualizado em várias ocasiões e hoje é um hotel moderno, com todas as comodidades e serviços, onde se respira em cada recanto a história e o romantismo do início do século XX.</>,
        sectionHeadSubtitle: "No centro de Camprodon",
        sectionHeadTitle: "Conheça os nossos quartos",
        sectionHeadTexts: <>{"Os quartos do hotel são "}<strong>grandes e confortáveis</strong>{". No total, "}<strong>35 quartos</strong>, cada um com a sua personalidade: quartos familiares grandes para famílias, quartos duplos para escapadinhas românticas e quartos económicos para grupos de amigos com vontade de desfrutar da natureza nos Pirenéus.</>,
        buttonHref: "/pt/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/pt/hotel/habitaciones",
        relatedRoomsImgAlt: "Quarto individual",
        relatedRoomsSmallTitle: "Quartos Hotel Camprodon",
        relatedRoomsTitle: "Quarto individual",
        relatedRoomsHref2: "/pt/hotel/habitaciones",
        relatedRoomsImgAlt2: "Quarto duplo básico",
        relatedRoomsSmallTitle2: "Quartos Hotel Camprodon",
        relatedRoomsTitle2: "Quarto duplo básico",
        relatedRoomsHref3: "/pt/hotel/habitaciones",
        relatedRoomsImgAlt3: "Quarto duplo standard",
        relatedRoomsSmallTitle3: "Quartos Hotel Camprodon",
        relatedRoomsTitle3: "Quarto duplo standard",
        relatedRoomsHref4: "/pt/hotel/habitaciones",
        relatedRoomsImgAlt4: "Quarto duplo superior",
        relatedRoomsSmallTitle4: "Quartos Hotel Camprodon",
        relatedRoomsTitle4: "Quarto duplo superior",
        relatedRoomsHref5: "/pt/hotel/habitaciones",
        relatedRoomsImgAlt5: "Quarto duplo superior com terraço",
        relatedRoomsSmallTitle5: "Quartos Hotel Camprodon",
        relatedRoomsTitle5: "Quarto duplo superior com terraço",
        relatedRoomsHref6: "/pt/hotel/habitaciones",
        relatedRoomsImgAlt6: "Quarto Junior Suite",
        relatedRoomsSmallTitle6: "Quartos Hotel Camprodon",
        relatedRoomsTitle6: "Quarto Junior Suite",
        relatedRoomsHref7: "/pt/hotel/habitaciones",
        relatedRoomsImgAlt7: "Quarto familiar quádruplo",
        relatedRoomsSmallTitle7: "Quartos Hotel Camprodon",
        relatedRoomsTitle7: "Quarto familiar quádruplo",
        sectionHeadSubtitle2: "Descubra as nossas instalações e serviços",
        sectionHeadTitle2: "Serviços do Hotel Camprodon",
        sectionHeadTexts2: <>{"O hotel dispõe de "}<strong>interiores acolhedores e agradáveis</strong>{", próprios do design modernista, com o Bar Albeniz e o restaurante. O exterior está rodeado de magníficas montanhas, que oferecem um cenário idílico à sua estadia e aos seus dias de descanso na nossa "}<strong>piscina e jardim</strong>.</>,
        sectionHeadTexts3: <><em>Não aceitamos animais de estimação</em>.</>,
        sliderControlsAboveAlt: "O seu hotel familiar nos Pirenéus",
        cardTitle: "No centro de Camprodon",
        cardContent: <>{"O Hotel Camprodon está situado no "}<strong>centro da vila</strong>{". As duas fachadas do hotel oferecem vistas aos seus "}<strong>35 quartos</strong>: uns com vista para a praça Doctor Robert e os outros para o rio Ter e a Pont Nou.</>,
        sliderControlsAboveAlt2: "O seu hotel familiar nos Pirenéus",
        cardTitle2: "Desligue ficando connosco",
        cardContent2: <>{"O Hotel Camprodon é o lugar ideal para vir desfrutar de um "}<strong>fim de semana</strong>{" ou de umas "}<strong>férias nos Pirenéus</strong>.</>,
        cardContent3: "Venha descobrir-nos!",
        sectionHeadSubtitle3: "Descubra as melhores ofertas em Camprodon",
        sectionHeadTitle3: "Ofertas do Hotel Camprodon",
        sectionHeadTexts4: "No Hotel Camprodon oferecemos pacotes e ofertas adaptados aos nossos clientes.",
        sectionHeadTexts5: <>{"Não perca a oportunidade de viver uma "}<strong>experiência única em Camprodon ao melhor preço</strong>. Explore as nossas ofertas hoje mesmo e reserve a sua estadia connosco!</>,
        buttonHref2: "/pt/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "Escapadinha de 2 noites em Camprodon",
        cardContent4: "Escapadinha de 2 noites em Camprodon às sextas e sábados de 7 de janeiro a 28 de fevereiro (exceto o fim de semana de 13 de fevereiro). Inclui alojamento, pequeno-almoço e acesso às instalações do hotel para desfrutar dos Pirenéus catalães no inverno.",
        linkHref: "/pt/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Descubra Camprodon",
        sectionHeadTitle4: "O que fazer em Camprodon?",
        sectionHeadTexts6: <>{"Venha descobrir a natureza nos "}<strong>Pirenéus de Girona</strong>{" e não perca as aldeias do "}<strong>Vale de Camprodon</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Desfrute dos Pirenéus mais autênticos com o Hotel Camprodon.",
        buttonHref3: "/pt/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "O seu hotel familiar nos Pirenéus",
        environmentContent: "Camprodon é conhecida pela sua rica história e cultura, e é um lugar ideal para quem procura uma escapadinha tranquila e relaxante.",
    },
    nl: {
        heroImageAlt: "Hotel in Camprodon",
        heroSmallTitle: "Een uitje naar een rustige en ontspannende plek",
        heroTitle: "Hotel in Camprodon",
        stickyWidgetsButtonHref: "/nl/buscar2",
        stickyWidgetsButtonHref2: "/nl/restaurante#reserva-restaurant",
        presentationTitle: "Jouw familiehotel in de Pyreneeën",
        presentationContent: <>{"Hotel Camprodon is een "}<strong>familiebedrijf</strong>{" uit 1914. Van "}<strong>modernistische</strong>{" oorsprong is het hotel meerdere keren vernieuwd en is het nu een eigentijds hotel met alle comfort en diensten, waar je in elk hoekje de geschiedenis en romantiek van het begin van de 20e eeuw voelt."}</>,
        sectionHeadSubtitle: "In het centrum van Camprodon",
        sectionHeadTitle: "Ontdek onze kamers",
        sectionHeadTexts: <>{"De kamers van het hotel zijn "}<strong>groot en comfortabel</strong>{". In totaal "}<strong>35 kamers</strong>, elk met een eigen karakter: grote familiekamers, tweepersoonskamers voor romantische uitjes en voordelige kamers voor vriendengroepen die van de natuur in de Pyreneeën willen genieten.</>,
        buttonHref: "/nl/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/nl/hotel/habitaciones",
        relatedRoomsImgAlt: "Eenpersoonskamer",
        relatedRoomsSmallTitle: "Kamers Hotel Camprodon",
        relatedRoomsTitle: "Eenpersoonskamer",
        relatedRoomsHref2: "/nl/hotel/habitaciones",
        relatedRoomsImgAlt2: "Tweepersoonskamer Basic",
        relatedRoomsSmallTitle2: "Kamers Hotel Camprodon",
        relatedRoomsTitle2: "Tweepersoonskamer Basic",
        relatedRoomsHref3: "/nl/hotel/habitaciones",
        relatedRoomsImgAlt3: "Tweepersoonskamer Standard",
        relatedRoomsSmallTitle3: "Kamers Hotel Camprodon",
        relatedRoomsTitle3: "Tweepersoonskamer Standard",
        relatedRoomsHref4: "/nl/hotel/habitaciones",
        relatedRoomsImgAlt4: "Tweepersoonskamer Superior",
        relatedRoomsSmallTitle4: "Kamers Hotel Camprodon",
        relatedRoomsTitle4: "Tweepersoonskamer Superior",
        relatedRoomsHref5: "/nl/hotel/habitaciones",
        relatedRoomsImgAlt5: "Tweepersoonskamer Superior met terras",
        relatedRoomsSmallTitle5: "Kamers Hotel Camprodon",
        relatedRoomsTitle5: "Tweepersoonskamer Superior met terras",
        relatedRoomsHref6: "/nl/hotel/habitaciones",
        relatedRoomsImgAlt6: "Junior suite",
        relatedRoomsSmallTitle6: "Kamers Hotel Camprodon",
        relatedRoomsTitle6: "Junior suite",
        relatedRoomsHref7: "/nl/hotel/habitaciones",
        relatedRoomsImgAlt7: "Vierpersoons familiekamer",
        relatedRoomsSmallTitle7: "Kamers Hotel Camprodon",
        relatedRoomsTitle7: "Vierpersoons familiekamer",
        sectionHeadSubtitle2: "Ontdek onze faciliteiten en diensten",
        sectionHeadTitle2: "Diensten van Hotel Camprodon",
        sectionHeadTexts2: <>{"Het hotel heeft "}<strong>warme en gezellige interieurs</strong>{" in typisch modernistische stijl, met Bar Albeniz en het restaurant. Buiten wordt het omringd door prachtige bergen, een idyllisch decor voor je verblijf en je rustdagen bij ons "}<strong>zwembad en de tuin</strong>.</>,
        sectionHeadTexts3: <><em>Huisdieren zijn niet toegestaan</em>.</>,
        sliderControlsAboveAlt: "Jouw familiehotel in de Pyreneeën",
        cardTitle: "In het centrum van Camprodon",
        cardContent: <>{"Hotel Camprodon ligt in het "}<strong>centrum van het dorp</strong>{". De twee gevels van het hotel bieden zijn "}<strong>35 kamers</strong>{" uitzicht: sommige op de Plaça Doctor Robert en andere op de Ter en de Pont Nou."}</>,
        sliderControlsAboveAlt2: "Jouw familiehotel in de Pyreneeën",
        cardTitle2: "Kom tot rust bij ons",
        cardContent2: <>{"Hotel Camprodon is de ideale plek voor een "}<strong>weekend</strong>{" of een "}<strong>vakantie in de Pyreneeën</strong>.</>,
        cardContent3: "Kom ons ontdekken!",
        sectionHeadSubtitle3: "Ontdek de beste aanbiedingen in Camprodon",
        sectionHeadTitle3: "Aanbiedingen van Hotel Camprodon",
        sectionHeadTexts4: "In Hotel Camprodon bieden we arrangementen en aanbiedingen op maat van onze gasten.",
        sectionHeadTexts5: <>{"Mis de kans niet om een "}<strong>unieke ervaring in Camprodon tegen de beste prijs</strong>{" te beleven. Bekijk vandaag nog onze aanbiedingen en boek je verblijf bij ons!"}</>,
        buttonHref2: "/nl/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "Uitje van 2 nachten in Camprodon",
        cardContent4: "Uitje van 2 nachten in Camprodon op vrijdag en zaterdag van 7 januari tot 28 februari (behalve het weekend van 13 februari). Inclusief overnachting, ontbijt en toegang tot de hotelfaciliteiten om in de winter van de Catalaanse Pyreneeën te genieten.",
        linkHref: "/nl/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Ontdek Camprodon",
        sectionHeadTitle4: "Wat te doen in Camprodon?",
        sectionHeadTexts6: <>{"Ontdek de natuur in de "}<strong>Pyreneeën van Girona</strong>{" en mis de dorpen van de "}<strong>Camprodonvallei</strong>{" niet: Setcases, Llanars, Molló..."}</>,
        sectionHeadTexts7: "Geniet van de meest authentieke Pyreneeën met Hotel Camprodon.",
        buttonHref3: "/nl/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "Jouw familiehotel in de Pyreneeën",
        environmentContent: "Camprodon staat bekend om zijn rijke geschiedenis en cultuur en is een ideale plek voor wie een rustig en ontspannen uitje zoekt.",
    },
    cs: {
        heroImageAlt: "Hotel v Camprodonu",
        heroSmallTitle: "Výlet na klidné a odpočinkové místo",
        heroTitle: "Hotel v Camprodonu",
        stickyWidgetsButtonHref: "/cs/buscar2",
        stickyWidgetsButtonHref2: "/cs/restaurante#reserva-restaurant",
        presentationTitle: "Váš rodinný hotel v Pyrenejích",
        presentationContent: <>{"Hotel Camprodon je "}<strong>rodinný</strong>{" hotel z roku 1914. Původně "}<strong>secesní</strong>{" hotel byl několikrát modernizován a dnes je to moderní hotel se vším pohodlím a službami, kde v každém koutě dýchá historie a romantika počátku 20. století."}</>,
        sectionHeadSubtitle: "V centru Camprodonu",
        sectionHeadTitle: "Poznejte naše pokoje",
        sectionHeadTexts: <>{"Pokoje hotelu jsou "}<strong>velké a pohodlné</strong>{". Celkem "}<strong>35 pokojů</strong>, každý s vlastní osobitostí: velké rodinné pokoje, dvoulůžkové pokoje pro romantické výlety a cenově výhodné pokoje pro skupiny přátel, které si chtějí užít přírodu v Pyrenejích.</>,
        buttonHref: "/cs/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/cs/hotel/habitaciones",
        relatedRoomsImgAlt: "Jednolůžkový pokoj",
        relatedRoomsSmallTitle: "Pokoje Hotel Camprodon",
        relatedRoomsTitle: "Jednolůžkový pokoj",
        relatedRoomsHref2: "/cs/hotel/habitaciones",
        relatedRoomsImgAlt2: "Dvoulůžkový pokoj Basic",
        relatedRoomsSmallTitle2: "Pokoje Hotel Camprodon",
        relatedRoomsTitle2: "Dvoulůžkový pokoj Basic",
        relatedRoomsHref3: "/cs/hotel/habitaciones",
        relatedRoomsImgAlt3: "Dvoulůžkový pokoj Standard",
        relatedRoomsSmallTitle3: "Pokoje Hotel Camprodon",
        relatedRoomsTitle3: "Dvoulůžkový pokoj Standard",
        relatedRoomsHref4: "/cs/hotel/habitaciones",
        relatedRoomsImgAlt4: "Dvoulůžkový pokoj Superior",
        relatedRoomsSmallTitle4: "Pokoje Hotel Camprodon",
        relatedRoomsTitle4: "Dvoulůžkový pokoj Superior",
        relatedRoomsHref5: "/cs/hotel/habitaciones",
        relatedRoomsImgAlt5: "Dvoulůžkový pokoj Superior s terasou",
        relatedRoomsSmallTitle5: "Pokoje Hotel Camprodon",
        relatedRoomsTitle5: "Dvoulůžkový pokoj Superior s terasou",
        relatedRoomsHref6: "/cs/hotel/habitaciones",
        relatedRoomsImgAlt6: "Junior Suite",
        relatedRoomsSmallTitle6: "Pokoje Hotel Camprodon",
        relatedRoomsTitle6: "Junior Suite",
        relatedRoomsHref7: "/cs/hotel/habitaciones",
        relatedRoomsImgAlt7: "Rodinný čtyřlůžkový pokoj",
        relatedRoomsSmallTitle7: "Pokoje Hotel Camprodon",
        relatedRoomsTitle7: "Rodinný čtyřlůžkový pokoj",
        sectionHeadSubtitle2: "Objevte naše vybavení a služby",
        sectionHeadTitle2: "Služby hotelu Hotel Camprodon",
        sectionHeadTexts2: <>{"Hotel nabízí "}<strong>teplé a příjemné interiéry</strong>{" v secesním stylu, s barem Albeniz a restaurací. Okolí tvoří nádherné hory, které jsou idylickým rámcem vašeho pobytu a dnů odpočinku u našeho "}<strong>bazénu a zahrady</strong>.</>,
        sectionHeadTexts3: <><em>Domácí zvířata nejsou povolena</em>.</>,
        sliderControlsAboveAlt: "Váš rodinný hotel v Pyrenejích",
        cardTitle: "V centru Camprodonu",
        cardContent: <>{"Hotel Camprodon se nachází v "}<strong>centru městečka</strong>{". Ze "}<strong>35 pokojů</strong>{" na obou fasádách hotelu jsou výhledy – jedny na náměstí Doctor Robert a druhé na řeku Ter a most Pont Nou."}</>,
        sliderControlsAboveAlt2: "Váš rodinný hotel v Pyrenejích",
        cardTitle2: "Odpočiňte si u nás",
        cardContent2: <>{"Hotel Camprodon je ideálním místem pro "}<strong>víkend</strong>{" nebo "}<strong>dovolenou v Pyrenejích</strong>.</>,
        cardContent3: "Přijeďte nás objevit!",
        sectionHeadSubtitle3: "Objevte nejlepší nabídky v Camprodonu",
        sectionHeadTitle3: "Nabídky hotelu Hotel Camprodon",
        sectionHeadTexts4: "V hotelu Hotel Camprodon nabízíme balíčky a nabídky přizpůsobené našim hostům.",
        sectionHeadTexts5: <>{"Nenechte si ujít příležitost zažít "}<strong>jedinečný zážitek v Camprodonu za nejlepší cenu</strong>. Prohlédněte si naše nabídky ještě dnes a rezervujte si u nás pobyt!</>,
        buttonHref2: "/cs/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "Pobyt na 2 noci v Camprodonu",
        cardContent4: "Pobyt na 2 noci v Camprodonu v pátek a sobotu od 7. ledna do 28. února (kromě víkendu 13. února). Zahrnuje ubytování, snídani a přístup k vybavení hotelu, abyste si užili katalánské Pyreneje v zimě.",
        linkHref: "/cs/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Objevte Camprodon",
        sectionHeadTitle4: "Co dělat v Camprodonu?",
        sectionHeadTexts6: <>{"Přijeďte objevit přírodu "}<strong>Pyrenejí v Gironě</strong>{" a nenechte si ujít vesnice "}<strong>údolí Camprodon</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Užijte si nejautentičtější Pyreneje s hotelem Hotel Camprodon.",
        buttonHref3: "/cs/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "Váš rodinný hotel v Pyrenejích",
        environmentContent: "Camprodon je známý svou bohatou historií a kulturou a je ideálním místem pro ty, kdo hledají klidný a odpočinkový pobyt.",
    },
    ru: {
        heroImageAlt: "Отель в Кампродоне",
        heroSmallTitle: "Отдых в тихом и спокойном месте",
        heroTitle: "Отель в Кампродоне",
        stickyWidgetsButtonHref: "/ru/buscar2",
        stickyWidgetsButtonHref2: "/ru/restaurante#reserva-restaurant",
        presentationTitle: "Ваш семейный отель в Пиренеях",
        presentationContent: <>{"Hotel Camprodon — "}<strong>семейный</strong>{" отель, основанный в 1914 году. Построенный в стиле "}<strong>модерн</strong>, отель неоднократно обновлялся и сегодня это современный отель со всеми удобствами и услугами, где в каждом уголке чувствуются история и романтика начала XX века.</>,
        sectionHeadSubtitle: "В центре Кампродона",
        sectionHeadTitle: "Наши номера",
        sectionHeadTexts: <>{"Номера отеля "}<strong>большие и комфортные</strong>{". Всего "}<strong>35 номеров</strong>, каждый со своим характером: большие семейные номера, двухместные номера для романтических поездок и недорогие номера для компаний друзей, желающих насладиться природой Пиренеев.</>,
        buttonHref: "/ru/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/ru/hotel/habitaciones",
        relatedRoomsImgAlt: "Одноместный номер",
        relatedRoomsSmallTitle: "Номера Hotel Camprodon",
        relatedRoomsTitle: "Одноместный номер",
        relatedRoomsHref2: "/ru/hotel/habitaciones",
        relatedRoomsImgAlt2: "Двухместный номер Basic",
        relatedRoomsSmallTitle2: "Номера Hotel Camprodon",
        relatedRoomsTitle2: "Двухместный номер Basic",
        relatedRoomsHref3: "/ru/hotel/habitaciones",
        relatedRoomsImgAlt3: "Двухместный номер Standard",
        relatedRoomsSmallTitle3: "Номера Hotel Camprodon",
        relatedRoomsTitle3: "Двухместный номер Standard",
        relatedRoomsHref4: "/ru/hotel/habitaciones",
        relatedRoomsImgAlt4: "Двухместный номер Superior",
        relatedRoomsSmallTitle4: "Номера Hotel Camprodon",
        relatedRoomsTitle4: "Двухместный номер Superior",
        relatedRoomsHref5: "/ru/hotel/habitaciones",
        relatedRoomsImgAlt5: "Двухместный номер Superior с террасой",
        relatedRoomsSmallTitle5: "Номера Hotel Camprodon",
        relatedRoomsTitle5: "Двухместный номер Superior с террасой",
        relatedRoomsHref6: "/ru/hotel/habitaciones",
        relatedRoomsImgAlt6: "Полулюкс (Junior Suite)",
        relatedRoomsSmallTitle6: "Номера Hotel Camprodon",
        relatedRoomsTitle6: "Полулюкс (Junior Suite)",
        relatedRoomsHref7: "/ru/hotel/habitaciones",
        relatedRoomsImgAlt7: "Семейный четырёхместный номер",
        relatedRoomsSmallTitle7: "Номера Hotel Camprodon",
        relatedRoomsTitle7: "Семейный четырёхместный номер",
        sectionHeadSubtitle2: "Наши удобства и услуги",
        sectionHeadTitle2: "Услуги отеля Hotel Camprodon",
        sectionHeadTexts2: <>{"В отеле "}<strong>тёплые и уютные интерьеры</strong>{" в стиле модерн, бар Albeniz и ресторан. Снаружи его окружают великолепные горы — идиллическая обстановка для вашего пребывания и дней отдыха у нашего "}<strong>бассейна и в саду</strong>.</>,
        sectionHeadTexts3: <><em>Размещение с домашними животными не допускается</em>.</>,
        sliderControlsAboveAlt: "Ваш семейный отель в Пиренеях",
        cardTitle: "В центре Кампродона",
        cardContent: <>{"Hotel Camprodon расположен в "}<strong>центре городка</strong>{". Из "}<strong>35 номеров</strong>{" на двух фасадах открываются виды: одни — на площадь Доктор Роберт, другие — на реку Тер и мост Понт-Ноу."}</>,
        sliderControlsAboveAlt2: "Ваш семейный отель в Пиренеях",
        cardTitle2: "Отключитесь от суеты у нас",
        cardContent2: <>{"Hotel Camprodon — идеальное место, чтобы провести "}<strong>выходные</strong>{" или "}<strong>отпуск в Пиренеях</strong>.</>,
        cardContent3: "Приезжайте к нам!",
        sectionHeadSubtitle3: "Лучшие предложения в Кампродоне",
        sectionHeadTitle3: "Предложения отеля Hotel Camprodon",
        sectionHeadTexts4: "В Hotel Camprodon мы предлагаем пакеты и предложения, адаптированные для наших гостей.",
        sectionHeadTexts5: <>{"Не упустите возможность получить "}<strong>уникальный опыт в Кампродоне по лучшей цене</strong>. Ознакомьтесь с нашими предложениями и забронируйте пребывание у нас!</>,
        buttonHref2: "/ru/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "Отдых на 2 ночи в Кампродоне",
        cardContent4: "Отдых на 2 ночи в Кампродоне по пятницам и субботам с 7 января по 28 февраля (кроме выходных 13 февраля). Включает проживание, завтрак и доступ к удобствам отеля, чтобы насладиться каталонскими Пиренеями зимой.",
        linkHref: "/ru/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Откройте для себя Кампродон",
        sectionHeadTitle4: "Чем заняться в Кампродоне?",
        sectionHeadTexts6: <>{"Откройте для себя природу "}<strong>Пиренеев Жироны</strong>{" и посетите деревни "}<strong>долины Кампродон</strong>: Сеткасес, Льянарс, Мольо...</>,
        sectionHeadTexts7: "Наслаждайтесь самыми настоящими Пиренеями вместе с Hotel Camprodon.",
        buttonHref3: "/ru/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "Ваш семейный отель в Пиренеях",
        environmentContent: "Кампродон известен богатой историей и культурой и идеально подходит тем, кто ищет спокойный и расслабляющий отдых.",
    },
    sv: {
        heroImageAlt: "Hotell i Camprodon",
        heroSmallTitle: "En resa till en lugn och avkopplande plats",
        heroTitle: "Hotell i Camprodon",
        stickyWidgetsButtonHref: "/sv/buscar2",
        stickyWidgetsButtonHref2: "/sv/restaurante#reserva-restaurant",
        presentationTitle: "Ditt familjehotell i Pyrenéerna",
        presentationContent: <>{"Hotel Camprodon är ett "}<strong>familjedrivet</strong>{" hotell från 1914. Med "}<strong>modernistiskt</strong>{" ursprung har hotellet moderniserats flera gånger och är i dag ett modernt hotell med alla bekvämligheter och tjänster, där man i varje hörn känner historien och romantiken från början av 1900-talet."}</>,
        sectionHeadSubtitle: "I centrala Camprodon",
        sectionHeadTitle: "Upptäck våra rum",
        sectionHeadTexts: <>{"Hotellets rum är "}<strong>stora och bekväma</strong>{". Totalt "}<strong>35 rum</strong>, alla med egen personlighet: stora familjerum, dubbelrum för romantiska resor och prisvärda rum för kompisgäng som vill njuta av naturen i Pyrenéerna.</>,
        buttonHref: "/sv/hotel/habitaciones",
        button: " Ver todo ",
        relatedRoomsHref: "/sv/hotel/habitaciones",
        relatedRoomsImgAlt: "Enkelrum",
        relatedRoomsSmallTitle: "Rum Hotel Camprodon",
        relatedRoomsTitle: "Enkelrum",
        relatedRoomsHref2: "/sv/hotel/habitaciones",
        relatedRoomsImgAlt2: "Dubbelrum Basic",
        relatedRoomsSmallTitle2: "Rum Hotel Camprodon",
        relatedRoomsTitle2: "Dubbelrum Basic",
        relatedRoomsHref3: "/sv/hotel/habitaciones",
        relatedRoomsImgAlt3: "Dubbelrum Standard",
        relatedRoomsSmallTitle3: "Rum Hotel Camprodon",
        relatedRoomsTitle3: "Dubbelrum Standard",
        relatedRoomsHref4: "/sv/hotel/habitaciones",
        relatedRoomsImgAlt4: "Dubbelrum Superior",
        relatedRoomsSmallTitle4: "Rum Hotel Camprodon",
        relatedRoomsTitle4: "Dubbelrum Superior",
        relatedRoomsHref5: "/sv/hotel/habitaciones",
        relatedRoomsImgAlt5: "Dubbelrum Superior med terrass",
        relatedRoomsSmallTitle5: "Rum Hotel Camprodon",
        relatedRoomsTitle5: "Dubbelrum Superior med terrass",
        relatedRoomsHref6: "/sv/hotel/habitaciones",
        relatedRoomsImgAlt6: "Junior svit",
        relatedRoomsSmallTitle6: "Rum Hotel Camprodon",
        relatedRoomsTitle6: "Junior svit",
        relatedRoomsHref7: "/sv/hotel/habitaciones",
        relatedRoomsImgAlt7: "Familjerum för fyra",
        relatedRoomsSmallTitle7: "Rum Hotel Camprodon",
        relatedRoomsTitle7: "Familjerum för fyra",
        sectionHeadSubtitle2: "Upptäck våra faciliteter och tjänster",
        sectionHeadTitle2: "Tjänster på Hotel Camprodon",
        sectionHeadTexts2: <>{"Hotellet har "}<strong>varma och trivsamma interiörer</strong>{" i typisk modernistisk stil, med Bar Albeniz och restaurangen. Utomhus omges det av magnifika berg som ger en idyllisk ram åt din vistelse och dina vilodagar vid vår "}<strong>pool och trädgård</strong>.</>,
        sectionHeadTexts3: <><em>Husdjur är inte tillåtna</em>.</>,
        sliderControlsAboveAlt: "Ditt familjehotell i Pyrenéerna",
        cardTitle: "I centrala Camprodon",
        cardContent: <>{"Hotel Camprodon ligger i "}<strong>byns centrum</strong>{". Hotellets två fasader ger utsikt åt dess "}<strong>35 rum</strong>: vissa mot Plaça Doctor Robert och andra mot floden Ter och Pont Nou.</>,
        sliderControlsAboveAlt2: "Ditt familjehotell i Pyrenéerna",
        cardTitle2: "Koppla av hos oss",
        cardContent2: <>{"Hotel Camprodon är den perfekta platsen för en "}<strong>helg</strong>{" eller en "}<strong>semester i Pyrenéerna</strong>.</>,
        cardContent3: "Kom och upptäck oss!",
        sectionHeadSubtitle3: "Upptäck de bästa erbjudandena i Camprodon",
        sectionHeadTitle3: "Erbjudanden på Hotel Camprodon",
        sectionHeadTexts4: "På Hotel Camprodon erbjuder vi paket och erbjudanden anpassade efter våra gäster.",
        sectionHeadTexts5: <>{"Missa inte chansen att få en "}<strong>unik upplevelse i Camprodon till bästa pris</strong>. Utforska våra erbjudanden redan idag och boka din vistelse hos oss!</>,
        buttonHref2: "/sv/ofertas-hotel-camprodon-girona/oferta-2-noches",
        button2: " Ver todo ",
        cardTitle3: "Miniresa 2 nätter i Camprodon",
        cardContent4: "Miniresa 2 nätter i Camprodon fredagar och lördagar från 7 januari till 28 februari (utom helgen den 13 februari). Inkluderar boende, frukost och tillgång till hotellets faciliteter för att njuta av de katalanska Pyrenéerna på vintern.",
        linkHref: "/sv/ofertas-hotel-camprodon-girona/oferta-2-noches",
        sectionHeadSubtitle4: "Upptäck Camprodon",
        sectionHeadTitle4: "Vad kan man göra i Camprodon?",
        sectionHeadTexts6: <>{"Kom och upptäck naturen i "}<strong>Gironas Pyrenéer</strong>{" och missa inte byarna i "}<strong>Camprodondalen</strong>: Setcases, Llanars, Molló...</>,
        sectionHeadTexts7: "Njut av de mest autentiska Pyrenéerna med Hotel Camprodon.",
        buttonHref3: "/sv/que-hacer-en-camprodon-girona",
        button3: " Ver todo ",
        environmentImgAlt: "Ditt familjehotell i Pyrenéerna",
        environmentContent: "Camprodon är känt för sin rika historia och kultur och är en perfekt plats för den som söker en lugn och avkopplande resa.",
    },
};

export default textos;
